import React, { PureComponent } from 'react'
import { isNull } from 'lodash'
import { WindowScroller, AutoSizer, Collection } from 'react-virtualized'
import matchMedia from 'matchmedia'
import breakpoints from '../styles/breakpoints'
import Spinner from '../common/Spinner'

// Helper for easy rendering virtualized list of objects cards
class ObjectCardVirtual extends PureComponent {
  constructor(props) {
    super(props)
    this.gutterSize = 10
    this.padding = 10
    this.height = 440
    this.columnWidth = 300
    this.columnColunt = 4
    this.updateGrid(window.innerWidth)
  }

  calculateColumnWidth = (width, columnColunt) => {
    return (
      (width - this.padding * 2 - (columnColunt - 1) * this.gutterSize) /
      columnColunt
    )
  }

  updateGrid = width => {
    if (matchMedia(`screen and (max-width: ${breakpoints.xs})`).matches) {
      this.columnCount = 1
    } else if (
      matchMedia(`screen and (max-width: ${breakpoints.sm})`).matches
    ) {
      this.columnCount = 2
    } else if (
      matchMedia(`screen and (max-width: ${breakpoints.md})`).matches
    ) {
      this.columnCount = 3
    } else if (
      matchMedia(`screen and (min-width: ${breakpoints.md})`).matches
    ) {
      this.columnCount = 4
    } else {
      this.columnCount = 4
    }
    this.columnWidth = this.calculateColumnWidth(width, this.columnCount)
  }

  cellRenderer = ({ index, isScrolling, key, style }) => {
    const { items, renderObjectCard } = this.props
    const item = items[index]

    return (
      <div key={key} style={style}>
        <div style={{ paddingTop: 5 }}>
          {renderObjectCard(item)}
        </div>
      </div>
    )
  }

  cellSizeAndPositionGetter = ({ index }) => {
    const columnPosition = index % (this.columnCount || 1)
    const rowPosition = Math.floor(index / this.columnCount)

    const x =
      this.padding + columnPosition * (this.gutterSize + this.columnWidth)
    // TODO: H e V
    const y = rowPosition * (this.gutterSize - 3 + this.height)

    return {
      height: this.height,
      width: this.columnWidth,
      x,
      y,
    }
  }

  onResize = ({ height, width }) => {
    this.updateGrid(width)
    this.collection.recomputeCellSizesAndPositions()
  }

  onSectionRendered = ({ indices }) => {
    if (
      indices[indices.length - 1] >= this.props.items.length - 10 &&
      !this.props.loading &&
      this.props.canLoadMoreItems
    ) {
      this.props.loadMore()
    }
  }

  render() {
    const { items, reRenderFor, loading, noContentRenderer } = this.props
    const reRenderProps = {
      items,
      ...reRenderFor,
    }

    return (
      <div>
        <WindowScroller>
          {({ height, scrollTop }) => (
            <AutoSizer
              disableHeight
              scrollTop={scrollTop}
              onResize={this.onResize}>
              {({ width }) => (
                <div>
                  <div style={{ width: width }}>
                    {loading && isNull(items) && <Spinner centered />}
                  </div>
                  <Collection
                    {...reRenderProps}
                    style={{ outline: 'none' }}
                    cellCount={isNull(items) ? 0 : items.length}
                    autoHeight={true}
                    cellSizeAndPositionGetter={this.cellSizeAndPositionGetter}
                    cellRenderer={this.cellRenderer}
                    onSectionRendered={this.onSectionRendered}
                    noContentRenderer={noContentRenderer}
                    height={height}
                    scrollTop={scrollTop}
                    width={width}
                    ref={r => {
                      this.collection = r
                    }}
                  />
                  <div style={{ width: width }}>
                    {loading &&
                      !isNull(items) &&
                      items.length > 0 &&
                      <Spinner centered />}
                  </div>
                </div>
              )}
            </AutoSizer>
          )}
        </WindowScroller>

      </div>
    )
  }
}

export default ObjectCardVirtual



// WEBPACK FOOTER //
// ./src/common/ObjectCardVirtual.js